/**
 * fetch's network-failure message in Chrome, Safari and Firefox; Sentry may
 * append the host, e.g. "Failed to fetch (trbotrkr.com)"
 */
const FETCH_NETWORK_ERROR =
  /^(Failed to fetch|Load failed|NetworkError when attempting to fetch resource)/

/**
 * Whether a fetch failed with no response at all (network down, blocked,
 * cancelled), as opposed to an API answering with an error status
 * @param {unknown} error
 * @returns {boolean}
 */
export const isFetchNetworkError = (error) =>
  error instanceof TypeError && FETCH_NETWORK_ERROR.test(error.message)
